import ReactAudioPlayer from 'react-audio-player';
import UsingDemo from '../../assets/audio/sing_demo_voice.mp3';
import { Button } from 'react-bootstrap';

import './SingTimePopup.scss';

const SingAlongPopup = ({ onSingAlongConfirm, onSingAlongReject }) => {
  return (
    <div className='sing-time-popup'>
      <ReactAudioPlayer src={UsingDemo} autoPlay />
      <h1>
        Would you like to sing along with the demo voice while you record?
      </h1>

      <Button variant='success' onClick={onSingAlongConfirm}>
        Yes
      </Button>
      <Button variant='danger' onClick={onSingAlongReject}>
        No
      </Button>
    </div>
  );
};

export default SingAlongPopup;
